import React from "react";
import {LangContainer, LangRow, ReturnBlock} from "./Language.styled";
import {ReactComponent as ReturnArrow} from '../../../assets/icons/back_arrow_new.svg'
import {ReactComponent as Dot} from '../../../assets/icons/ex_dot.svg'
import {useAppDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";
import {selectors} from "../../../redux/selectors";
import {setIsLangOpen, setLang} from "../../../redux/actions";
import {LANG_KEY} from "../../../constants";
export const Language:React.FC = () => {
    const dispatch = useAppDispatch()
    const lang = useSelector(selectors.selectLang)
    return (
        <LangContainer>
            <ReturnBlock onClick={() => {
                dispatch(setIsLangOpen(false))
            }}>
                <ReturnArrow/>
                {lang === 'en' ? 'BACK' : 'НАЗАД'}
            </ReturnBlock>
            <LangRow
                $isActive={lang === 'en'}
                onClick={() => {
                    localStorage.setItem(LANG_KEY, JSON.stringify('en'))
                    dispatch(setLang('en'))
                }}
            >
                ENGLISH
                <Dot/>
            </LangRow>
            <LangRow
                $isActive={lang === 'ua'}
                onClick={() => {
                    localStorage.setItem(LANG_KEY, JSON.stringify('ua'))
                    dispatch(setLang('ua'))
                }}
            >
                УКРАЇНСЬКА
                <Dot/>
            </LangRow>
        </LangContainer>
    )
}